<nav class="snav">
  @for (item of items(); track item.id) {
    <button
      class="snav-item"
      [class.snav-item--active]="activeId() === item.id"
      [class.snav-item--group]="item.selectable === false"
      (click)="onItemClick(item)"
    >
      @if (item.icon) {
        <i class="{{ item.icon }} snav-item-icon"></i>
      }
      <span class="snav-item-label">{{ item.label }}</span>
      @if (item.meta) {
        <span class="snav-meta">{{ item.meta }}</span>
      }
      @if (item.badge !== null && item.badge !== undefined && item.badge > 0) {
        <span class="snav-badge">{{ item.badge }}</span>
      }
    </button>

    @if (item.children?.length) {
      <ul class="snav-children">
        @for (child of item.children; track child.id) {
          <li>
            <button
              class="snav-child"
              [title]="child.label"
              [class.snav-child--active]="activeId() === child.id"
              (click)="onChildClick(item, child)"
            >
              <span class="snav-child-label">{{ child.label }}</span>
              @if (child.meta) {
                <span class="snav-meta">{{ child.meta }}</span>
              }
            </button>
          </li>
        }
      </ul>
    }
  }
</nav>
